// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__ZLxgr","options":"AnswerScale_options__31Rh0","selected":"AnswerScale_selected__LZERo"};